export function getBaseMapStyle( type ){
    let style = "dark";
    if( type == "esri_sat" || type == "globe_dark" )
        style = "light";
    return style;
}

export function getMapLayers( type ){
    if( type == "basic" )
        return ['coast','coast-h','coast-us','cntry','cntry-h','cntry-us','state','state-h','state-us','europe-state','asia-state','russia-state','america-state','island','island-us','lake','lake-us'];
    if( type == "county" )
        return ['county','county-us','county-h','county_data'];
    if( type == "city" )
        return ['city','city_data','city_data_mid','city_data_sm','city_data_xsm'];
    if( type == "highway" )
        return ['highway','highway-h','highway-us'];
    if( type == "road" )
        return ['major-road','minor-road','street'];
    if( type == "rail" )
        return ['rail'];
    if( type == "river" )
        return ['river','river-us','river-h','water-h','river-h2','water-h2','river-h3','water-h3'];
    if( type == "runway" )
        return ['airport'];
    if( type == "jetroute" )
        return ['topjetroutes','jetroutes'];
    if( type == "qroute" )
        return ['qroutes'];
    if( type == "airway" )
        return ['vairways'];
    if( type == "airspace" )
        return ['class_e','class_d','class_c','class_b'];
    if( type == "sua" )
        return ['sua_moa','sua_r','sua_data'];
    if( type == "cwarn" )
        return ['cwa','cwa_data'];
    if( type == "fir" )
        return ['fir2024','fir_data'];
    if( type == "latlon" )
        return ['latlon'];
    return [];
}

export function getRegion( name ){
    if( name == "conus" || name == "us" )
        return [ 39, -97, 4 ];
    else if( name == "northeast" || name == "ne" )
        return [ 42, -82, 5 ];
    else if( name == "southeast" || name == "se" )
        return [ 33, -88, 5 ];
    else if( name == "northcentral" || name == "nc" )
        return [ 42, -98, 5 ];
    else if( name == "southcentral" || name == "sc" )
        return [ 35, -99, 5 ];
    else if( name == "northwest" || name == "nw" )
        return [ 42, -112, 5 ];
    else if( name == "southwest" || name == "sw" )
        return [ 37, -112, 5 ];
    else if( name == "alaska" || name == "ak" )
        return [ 65, -155, 4 ];
    else if( name == "hawaii" || name == "hi" )
        return [ 21, -157, 5 ];
    else if( name == "gulfmexico" || name == "gmx" )
        return [ 25, -91, 5 ];
    else if( name == "caribbean" || name == "car" )
        return [ 15, -75, 5 ];
    else if( name == "east_carib" || name == "ecar" )
        return [ 15, -66, 6 ];
    else if( name == "europe" || name == "eur" )
        return [ 50, 15, 4 ];
    else if( name == "southamerica" || name == "sam" )
        return [ -20, -55, 4 ];
    else if( name == "easia" || name == "eas" )
        return [ 35, 115, 4 ];
    else if( name == "australia" || name == "aus" )
        return [ -25, 130, 4 ];

    return [ 39, -97, 4 ];
}

